import React, { ChangeEvent, useEffect } from 'react';

import { Box, BoxProps, Button, FormControl, FormLabel, Select, Stack, useBreakpointValue } from '@chakra-ui/react';

import { TypeArea, TypeCity } from 'generated/contentful';

import { Field, Form, useFormikContext } from 'formik';

import { JobsBoardSearchFormFields, JobsBoardSearchFormSchemaType } from './JobsBoard.schema';

interface JobsBoardSearchFormProps {
  city: TypeCity<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  cities: TypeCity<'WITHOUT_UNRESOLVABLE_LINKS', string>[];
  area?: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  areas: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>[];
}

export default function JobsBoardSearchForm({
  city,
  cities,
  area,
  areas,
  ...boxProps
}: JobsBoardSearchFormProps & BoxProps) {
  const { handleChange, isSubmitting, setFieldValue, values } = useFormikContext<JobsBoardSearchFormSchemaType>();
  const selectSize = useBreakpointValue({ base: 'md', md: 'lg' });

  useEffect(() => {
    // City has changed.
    if (city.fields.slug !== values.city) {
      setFieldValue(JobsBoardSearchFormFields.City, city.fields.slug);
    }

    // Area has changed.
    if (!area) {
      setFieldValue(JobsBoardSearchFormFields.Area, null);
    }
    if (area && area.fields.slug !== values.area) {
      setFieldValue(JobsBoardSearchFormFields.Area, area.fields.slug);
    }
  }, [city, area]);
  return (
    <Box {...boxProps}>
      <Form>
        <Stack direction={['column', null, 'row']} spacing={4} alignItems="flex-end">
          <FormControl>
            <FormLabel>City</FormLabel>
            <Field
              as={Select}
              size={selectSize}
              name={JobsBoardSearchFormFields.City}
              value={values.city !== null ? values.city : ''}
              onChange={(e: ChangeEvent) => {
                // When the city is changed, the area value is set to null.
                handleChange(e);
                setFieldValue(JobsBoardSearchFormFields.Area, null);
              }}
            >
              {cities.map((city, index) => (
                <option key={index} value={city.fields.slug}>
                  {city.fields.name}
                </option>
              ))}
            </Field>
          </FormControl>
          <FormControl>
            <FormLabel>Location</FormLabel>
            <Field
              as={Select}
              size={selectSize}
              name={JobsBoardSearchFormFields.Area}
              value={values.area !== null ? values.area : ''}
            >
              <option value="">All</option>
              {areas
                .filter(area => {
                  return area.fields.city?.fields.slug === values.city;
                })
                .map((area, index) => (
                  <option key={index} value={area.fields.slug}>
                    {area.fields.name}
                  </option>
                ))}
            </Field>
          </FormControl>

          <Button width={['100%', null, '40%']} isLoading={isSubmitting} colorScheme="cyan" size="lg" type="submit">
            <span>Search</span>
          </Button>
        </Stack>
      </Form>
    </Box>
  );
}
